(() => {
  const setup = (root) => root.querySelectorAll('.southwood-usp__track').forEach((track) => {
    if (track.dataset.rotating) return;
    track.dataset.rotating = 'true';
    let timer;
    let hovered = false;
    let focused = false;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (motion.matches || hovered || focused || document.hidden || track.scrollWidth <= track.clientWidth + 2) return;
      timer = window.setInterval(() => {
        if (!track.isConnected) {stop(); return;}
        const step = track.firstElementChild.getBoundingClientRect().width;
        const next = track.scrollLeft + step;
        track.scrollTo({left: next > track.scrollWidth - track.clientWidth + 2 ? 0 : next, behavior: 'smooth'});
      }, 3000);
    };
    track.addEventListener('mouseenter', () => {hovered = true; stop();});
    track.addEventListener('mouseleave', () => {hovered = false; start();});
    track.addEventListener('focusin', () => {focused = true; stop();});
    track.addEventListener('focusout', () => {focused = false; start();});
    track.addEventListener('touchstart', stop, {passive:true});
    track.addEventListener('touchend', start, {passive:true});
    document.addEventListener('visibilitychange', start);
    motion.addEventListener('change', start);
    new ResizeObserver(start).observe(track);
    start();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(document), {once:true});
  else setup(document);
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
